import QRCode from 'qrcode';

const censorWord = (str) => {
  const repeatLength = str.length >= 5 ? 3 : str.length - 2;
  return str[0] + '*'.repeat(repeatLength) + str.slice(-1);
};
export function limitString(text, count) {
  return text.slice(0, count) + (text.length > count ? '...' : '');
}
export const camelizeUnderScore = (str) => {
  let i = 0;
  const frags = str.split('_');
  for (i = 0; i < frags.length; i += 1) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(' ');
};
export const censorEmail = (email) => {
  if (!email) return '';
  const arr = email.split('@');
  return `${censorWord(arr[0])}@${censorWord(arr[1])}`;
};

// eslint-disable-next-line consistent-return
export const generateQR = async (text) => {
  try {
    return await QRCode.toDataURL(text);
  } catch (err) {
    console.log(err);
  }
};
